import React from "react";
import "./compareReits.less";
import FinancialTable from "./financial-table/financialTable";

const CompareReits: React.FC = () => {
  const displayName = "cmp-compare-reits";

  return (
    <div className={displayName}>
      <section className={`${displayName}__banner`}>
        <div className={`${displayName}__text`}>
          <h1>
            Compare <span>REITs</span>
          </h1>
          <p>
            Easily review REITs side-by-side to identify opportunities that
            match your financial goals and risk appetite.
          </p>
        </div>
      </section>

      <FinancialTable />
    </div>
  );
};

export default CompareReits;
